/* ============================================================
   eQiik — scripts propios (vanilla, sin librerías)
   Una función init por componente; cada una comprueba si su
   elemento existe antes de actuar.
   ============================================================ */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Utilidades compartidas por la ficha de producto ---- */
  function money(cents) {
    var v = (cents / 100);
    return v.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  // Variantes del inodoro (y su stock), del bloque de datos de la ficha. Se
  // leen de ahí y no de los botones de la pantalla, que NO se pintan si el
  // producto tiene un solo modelo.
  function eqVariantes() {
    var el = document.querySelector('[data-eq-variants]');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
  }
  function eqVarianteActual(form) {
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    if (!idInput) return null;
    var vs = eqVariantes();
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].id) === String(idInput.value)) return vs[i];
    }
    return null;
  }
  // Unidades que admite de verdad la variante (null = sin límite: sin
  // seguimiento de inventario o con «seguir vendiendo sin stock»).
  function eqTope(v) {
    if (!v || !v.managed || v.stock == null || v.policy === 'continue') return null;
    return v.stock;
  }
  // Pago rápido («Comprar ahora»): solo se ve si el modelo elegido se puede
  // comprar Y la casilla de instalación está desmarcada (el pago rápido solo
  // lleva un artículo). Lo llaman el selector de modelo y la casilla, así
  // nunca se contradicen.
  function eqPagoRapido(form) {
    if (!form) return;
    var pb = form.querySelector('.shopify-payment-button');
    if (!pb) return;
    var check = form.querySelector('[data-eq-instal-check]');
    var v = eqVarianteActual(form);
    var ok = (!v || v.available) && !(check && check.checked);
    pb.style.display = ok ? '' : 'none';
  }

  /* ---- Reveals al hacer scroll ----
     Umbral 0 y margen pequeño: al bajar rápido ya no quedan huecos en blanco
     esperando a que un bloque «entre». Lo que ya quedó por encima (salto con
     un ancla, recarga a media página) se marca visible directamente. */
  function initReveals() {
    var els = document.querySelectorAll('.eq-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('eq-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
          entry.target.classList.add('eq-visible');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ---- */
  function initCountUp() {
    var nums = document.querySelectorAll('[data-countup]');
    if (!nums.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-countup'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-countup'));
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = target * eased;
          el.textContent = (target % 1 === 0) ? Math.round(val) : val.toFixed(1);
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = el.getAttribute('data-countup');
        }
        requestAnimationFrame(step);
        obs.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { obs.observe(n); });
  }

  /* ---- FAQ acordeón ----
     El estado (aria-expanded) va en el botón, que es lo que anuncia el lector
     de pantalla; aria-controls apunta a su respuesta. */
  function initFaq() {
    var btns = document.querySelectorAll('.eq-faq__q');
    if (!btns.length) return;
    var abiertas = [];
    btns.forEach(function (btn) {
      var item = btn.closest ? btn.closest('.eq-faq__item') : btn.parentNode;
      var ans = item ? item.querySelector('.eq-faq__a') : null;
      if (!ans) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        ans.style.maxHeight = open ? null : ans.scrollHeight + 'px';
        var k = abiertas.indexOf(ans);
        if (open && k !== -1) abiertas.splice(k, 1);
        if (!open && k === -1) abiertas.push(ans);
      });
    });
    // Al girar el móvil o cambiar el ancho, el texto ocupa otras líneas: se
    // recalcula el alto de las abiertas para que no se corten.
    var pendiente = false;
    window.addEventListener('resize', function () {
      if (pendiente || !abiertas.length) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        abiertas.forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      });
    }, { passive: true });
  }

  /* ---- Galería de producto ----
     Cambio suave (la foto nueva se descarga y decodifica antes de mostrarse),
     deslizar con el dedo sobre la foto grande, flechas del teclado en las
     miniaturas, y la miniatura activa se centra en la tira. */
  function initGallery() {
    var gallery = document.querySelector('[data-eq-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-eq-main-img]');
    var thumbs = [].slice.call(gallery.querySelectorAll('.eq-prod__thumb'));
    if (!main || thumbs.length < 2) return;
    var strip = gallery.querySelector('.eq-prod__thumbs');
    var frame = main.parentNode;
    var actual = 0, turno = 0;
    thumbs.forEach(function (t, k) { if (t.classList.contains('is-active')) actual = k; });

    // Degradado de la derecha: solo mientras quedan miniaturas por ver
    function marcaFin() {
      if (!strip) return;
      var fin = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
      strip.classList.toggle('is-fin', fin);
    }
    function centra(t) {
      if (!strip) return;
      var izq = t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2;
      if (strip.scrollTo) strip.scrollTo({ left: Math.max(0, izq), behavior: reduceMotion ? 'auto' : 'smooth' });
      else strip.scrollLeft = Math.max(0, izq);
    }

    function mostrar(i) {
      var n = thumbs.length;
      i = ((i % n) + n) % n;
      if (i === actual) return;
      actual = i;
      var t = thumbs[i];
      thumbs.forEach(function (b, k) {
        var on = k === i;
        b.classList.toggle('is-active', on);
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
      centra(t);

      var src = t.getAttribute('data-full');
      if (!src) return;
      var srcset = t.getAttribute('data-srcset');
      var alt = t.getAttribute('data-alt') || '';
      var mio = ++turno;
      function pon() {
        if (mio !== turno) return; // el cliente ya pidió otra foto
        if (srcset) main.setAttribute('srcset', srcset);
        else main.removeAttribute('srcset');
        main.src = src;
        main.alt = alt;
        main.classList.remove('is-cambiando');
      }
      if (reduceMotion || !window.Promise) { pon(); return; }
      main.classList.add('is-cambiando');
      var pre = new Image();
      if (srcset) {
        pre.sizes = main.getAttribute('sizes') || '100vw';
        pre.srcset = srcset;
      }
      pre.src = src;
      var cargada = pre.decode
        ? pre.decode().catch(function () {})
        : new Promise(function (r) { pre.onload = pre.onerror = r; });
      var fundido = new Promise(function (r) { setTimeout(r, 160); });
      // Si la red va muy lenta, no se deja la foto en blanco para siempre
      var limite = new Promise(function (r) { setTimeout(r, 2500); });
      Promise.race([Promise.all([cargada, fundido]), limite]).then(pon);
    }

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { mostrar(k); });
    });

    // Flechas del teclado cuando el foco está en una miniatura
    gallery.addEventListener('keydown', function (e) {
      if (!e.target.classList || !e.target.classList.contains('eq-prod__thumb')) return;
      var paso = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!paso) return;
      e.preventDefault();
      mostrar(thumbs.indexOf(e.target) + paso);
      thumbs[actual].focus();
    });

    // Deslizar con el dedo sobre la foto grande (umbral 40 px, solo gestos
    // más horizontales que verticales para no estorbar al scroll de la página)
    var x0 = null, y0 = null;
    frame.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { x0 = null; return; }
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    frame.addEventListener('touchend', function (e) {
      if (x0 == null || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      mostrar(actual + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if (strip) {
      strip.addEventListener('scroll', marcaFin, { passive: true });
      window.addEventListener('resize', marcaFin, { passive: true });
      marcaFin();
    }
  }

  /* ---- Selector de variantes ---- */
  function initVariants() {
    var form = document.querySelector('[data-eq-product-form]');
    if (!form) return;
    var dataEl = document.querySelector('[data-eq-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-eq-price]');
    var addBtn = form.querySelector('[data-eq-add]');
    var buttons = document.querySelectorAll('.eq-prod__variant');
    if (!buttons.length) return;

    // Cuota de Klarna (precio ÷ 3, redondeo a la baja, igual que muestra Klarna)
    function updateKlarna(cents) {
      var el = document.querySelector('[data-eq-klarna-cuota]');
      if (el && cents != null) el.textContent = money(Math.floor(cents / 3));
    }
    // Etiqueta de la oferta de lanzamiento: se actualiza (o se oculta) según el modelo
    function updateOferta(v) {
      var badge = document.querySelector('[data-eq-oferta]');
      if (!badge) return;
      var dto = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
      var dtoEl = badge.querySelector('[data-eq-oferta-dto]');
      if (dtoEl && dto) dtoEl.textContent = '−' + money(dto);
      badge.style.display = dto ? '' : 'none';
    }
    function select(variantId) {
      var v = variants.filter(function (x) { return String(x.id) === String(variantId); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        var html = '<span>' + money(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<del>' + money(v.compare_at_price) + '</del>';
        }
        priceEl.innerHTML = html;
      }
      updateOferta(v);
      updateKlarna(v.price);
      eqSetVariantUrl(v.id);
      // Si hay casilla de instalación, de avisar a Klarna se encarga refrescar()
      // (que sabe si hay que sumar los 290 €): así no se le pide redibujarse
      // dos veces seguidas por el mismo cambio.
      if (!document.querySelector('[data-eq-instal-check]')) eqKlarnaWidget(v.price);
      // Pago rápido: fuera si el modelo está agotado (o la casilla marcada)
      eqPagoRapido(form);
      // La casilla de instalación recalcula su cuota al cambiar de modelo
      // (y vuelve a avisar a Klarna con el importe que incluye la instalación)
      document.dispatchEvent(new CustomEvent('eq:variant-change'));
      if (addBtn) {
        if (v.available) { addBtn.removeAttribute('disabled'); addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito'; }
        else { addBtn.setAttribute('disabled', 'disabled'); addBtn.textContent = 'Agotado'; }
      }
      // Un aviso de stock del modelo anterior ya no vale para este
      var errEl = form.querySelector('[data-eq-instal-error]');
      if (errEl) errEl.hidden = true;
      // Escasez real: aviso de últimas unidades (singular/plural según stock),
      // bloque de agotado y tope de cantidad siguen al inventario de la variante
      var stockEl = document.querySelector('[data-eq-stock]');
      if (stockEl) {
        var pocas = v.available && v.managed && v.stock != null && v.stock > 0 && v.stock <= 2;
        stockEl.hidden = !pocas;
        var stockTxt = stockEl.querySelector('[data-eq-stock-txt]');
        if (stockTxt && pocas) {
          var txtVarias = stockEl.getAttribute('data-texto-varias') || '';
          var txtUna = stockEl.getAttribute('data-texto-una') || '';
          if (v.stock > 1 && txtVarias) stockTxt.textContent = txtVarias.replace('{stock}', v.stock);
          else if (txtUna) stockTxt.textContent = txtUna;
        }
      }
      var agotadoEl = document.querySelector('[data-eq-agotado]');
      if (agotadoEl) agotadoEl.hidden = !!v.available;
      var qtyIn = document.querySelector('[data-eq-qty-input]');
      if (qtyIn) {
        if (v.managed && v.stock > 0) {
          qtyIn.setAttribute('max', String(v.stock));
          if (parseInt(qtyIn.value, 10) > v.stock) qtyIn.value = v.stock;
        } else {
          qtyIn.removeAttribute('max');
        }
      }
      // El aviso de «1 unidad por pedido» solo aparece cuando de verdad el tope
      // es una: si no, el «+» sí funciona y el aviso sobraría.
      var qtyNota = document.querySelector('[data-eq-qty-nota]');
      if (qtyNota) qtyNota.hidden = !(v.managed && v.stock === 1);
    }
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        select(btn.getAttribute('data-variant-id'));
      });
    });
    // Estado inicial del pago rápido (p. ej. si se entra con un modelo agotado)
    eqPagoRapido(form);
  }

  /* ---- Selector de cantidad ---- */
  function initQty() {
    var box = document.querySelector('[data-eq-qty]');
    if (!box) return;
    var input = box.querySelector('[data-eq-qty-input]');
    var minus = box.querySelector('[data-eq-qty-minus]');
    var plus = box.querySelector('[data-eq-qty-plus]');
    if (!input) return;
    function clamp() {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      input.value = v;
    }
    // El «+» respeta el tope de existencias (atributo max, si existe)
    function tope() {
      var m = parseInt(input.getAttribute('max'), 10);
      return isNaN(m) ? Infinity : m;
    }
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = Math.min(tope(), (parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('change', function () {
      clamp();
      var m = tope();
      if (parseInt(input.value, 10) > m) input.value = m;
    });
  }

  /* ---- Widget oficial de Klarna ----
     El widget de Klarna solo lee el «?variant=» de la dirección cuando se
     carga la página. Si el cliente cambiaba de modelo o marcaba la instalación,
     se quedaba con el importe del primer modelo y enseñaba una cuota que no era
     la suya, contradiciendo a nuestra propia línea de financiación justo en la
     pantalla donde se decide. Aquí se le pasa el importe real y se le pide que
     se vuelva a dibujar. */
  function eqKlarnaWidget(cents) {
    if (cents == null || !isFinite(cents) || cents <= 0) return;
    var phs = document.querySelectorAll('klarna-placement');
    if (!phs.length) return;
    for (var i = 0; i < phs.length; i++) {
      phs[i].setAttribute('data-purchase-amount', String(Math.round(cents)));
    }
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging &&
          typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
      }
    } catch (e) {}
  }

  /* La dirección refleja el modelo elegido: así Klarna acierta también al
     recargar, el enlace del modelo se puede compartir y el botón «atrás» del
     navegador recuerda cuál estaba elegido. */
  function eqSetVariantUrl(id) {
    if (!id || !window.history || !window.history.replaceState) return;
    try {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', String(id));
      window.history.replaceState({}, '', u.toString());
    } catch (e) {}
  }

  /* ---- Instalación profesional opcional ----
     Aquí solo se pintan los importes y se decide qué se ve. El envío al
     carrito (con o sin la casilla) lo hace initEnvio(), un único manejador. */
  function initInstalacion() {
    var form = document.querySelector('[data-eq-product-form]');
    var check = document.querySelector('[data-eq-instal-check]');
    if (!form || !check) return;
    var instalPrice = parseInt(check.getAttribute('data-price'), 10) || 0;

    function precioVarianteActual() {
      var v = eqVarianteActual(form);
      return v ? v.price : 0;
    }
    // Con la casilla marcada, TODO lo que habla de dinero refleja inodoro +
    // instalación: nuestra cuota, el widget oficial de Klarna y el total.
    // El pago rápido (Comprar ahora) solo lleva un artículo, así que se oculta
    // para que el pedido nunca llegue sin la instalación — y se explica al
    // lado, para que al cliente no le desaparezca un botón sin motivo.
    function refrescar() {
      var base = precioVarianteActual();
      var extra = check.checked ? instalPrice : 0;
      var el = document.querySelector('[data-eq-klarna-cuota]');
      if (el) el.textContent = money(Math.floor((base + extra) / 3));
      // El widget oficial de Klarna recalcula el importe él solo a partir de la
      // variante de la dirección, así que no acepta que le sumemos los 290 € de
      // la instalación: enseñaría la cuota del inodoro suelto justo al lado de
      // la nuestra, ya sumada. Con la casilla marcada se oculta — mejor una
      // cifra correcta que dos que se contradicen. Sin marcar, vuelve y
      // coincide exactamente con la nuestra.
      var kp = document.querySelector('klarna-placement');
      var kbox = kp ? ((kp.closest && kp.closest('.eq-prod__appblock')) || kp) : null;
      if (kbox) kbox.style.display = check.checked ? 'none' : '';
      // Solo se le pide redibujarse cuando está a la vista: dentro de un
      // contenedor oculto a veces se queda en blanco al volver a mostrarlo.
      if (!check.checked) eqKlarnaWidget(base);
      var tot = document.querySelector('[data-eq-instal-total]');
      if (tot) {
        tot.textContent = 'Total con instalación: ' + money(base + extra);
        tot.hidden = !check.checked;
      }
      // Pago rápido: visible solo con modelo disponible Y casilla desmarcada
      eqPagoRapido(form);
      var nota = document.querySelector('[data-eq-instal-pago]');
      if (nota) nota.hidden = !check.checked;
    }
    check.addEventListener('change', refrescar);
    document.addEventListener('eq:variant-change', refrescar);

    // Al volver atrás, el navegador restaura la página tal y como estaba: la
    // casilla marcada volvía sin el total ni el aviso. Aquí se repinta.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return; // en la carga normal ya lo hace el refrescar() final
      refrescar();
    });

    // Los navegadores recuerdan la casilla marcada al recargar o al volver
    // atrás, así que hay que pintar los importes al arrancar: si no, quedaba
    // marcada pero sin total y con el botón de pago rápido otra vez visible.
    refrescar();
  }

  /* ---- Envío al carrito de la ficha (con o sin instalación) ----
     Un solo manejador para el formulario. Antes, sin la casilla marcada, el
     formulario se enviaba tal cual y dejaba meter más unidades de las que hay
     (con 1 eQiik ya en el carrito y stock 1 se llegó a eQiik x2 = 998 €).
     Ahora siempre se mira el carrito y el stock real antes de añadir. */
  function initEnvio() {
    var form = document.querySelector('[data-eq-product-form]');
    if (!form) return;
    // Navegadores muy antiguos: se deja el envío normal del formulario
    if (!window.fetch || !window.Promise) return;
    var addBtn = form.querySelector('[data-eq-add]');
    var errEl = form.querySelector('[data-eq-instal-error]');
    if (!errEl) {
      errEl = document.createElement('p');
      errEl.className = 'eq-prod__error';
      errEl.setAttribute('role', 'alert');
      errEl.setAttribute('data-eq-instal-error', '');
      errEl.hidden = true;
      if (addBtn && addBtn.parentNode) addBtn.parentNode.insertBefore(errEl, addBtn.nextSibling);
      else form.appendChild(errEl);
    }

    var enviando = false;
    function restaurarBoton() {
      enviando = false;
      if (addBtn && addBtn.getAttribute('data-eq-enviando')) {
        addBtn.removeAttribute('data-eq-enviando');
        // Si el modelo elegido está agotado, el botón sigue bloqueado
        var v = eqVarianteActual(form);
        if (v && !v.available) {
          addBtn.setAttribute('disabled', 'disabled');
          addBtn.textContent = 'Agotado';
        } else {
          addBtn.removeAttribute('disabled');
          addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito';
        }
      }
    }
    // Aviso junto al botón, con enlace al carrito cuando ayuda
    function aviso(msg, conCarrito, esInfo) {
      errEl.textContent = msg;
      errEl.classList.toggle("is-info", !!esInfo);
      if (conCarrito) {
        errEl.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = '/cart';
        a.textContent = 'Ver carrito';
        errEl.appendChild(a);
      }
      errEl.hidden = false;
    }
    function avisoError(msg) {
      var tel = errEl.getAttribute('data-tel');
      aviso(msg || ('No hemos podido añadirlo al carrito. Vuelve a intentarlo' +
        (tel ? ' o llámanos al ' + tel : '') + '.'));
    }
    // Al volver atrás el botón se quedaba en «Añadiendo…» y sin responder
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) restaurarBoton();
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (enviando) return; // en un móvil lento es normal tocar dos veces

      var check = form.querySelector('[data-eq-instal-check]');
      var conInstal = !!(check && check.checked);
      var instalId = check ? parseInt(check.getAttribute('data-variant'), 10) : NaN;
      var idInput = form.querySelector('input[name="id"]');
      var qtyIn = form.querySelector('[data-eq-qty-input]');
      var qty = qtyIn ? (parseInt(qtyIn.value, 10) || 1) : 1;
      if (qty < 1) qty = 1;
      var varId = idInput ? parseInt(idInput.value, 10) : NaN;
      errEl.hidden = true;
      if (isNaN(varId)) { avisoError(null); return; }

      enviando = true;
      var yaAnadido = false;
      var parcial = '';
      if (addBtn) {
        addBtn.setAttribute('disabled', 'disabled');
        addBtn.setAttribute('data-eq-enviando', '1');
        addBtn.textContent = 'Añadiendo…';
      }
      // Shopify explica el motivo mucho mejor que un mensaje genérico
      // (p. ej. «Tu carrito ya tiene la cantidad máxima de este artículo»).
      function fallo(r) {
        return r.json().then(function (d) {
          throw new Error((d && (d.description || d.message)) || '');
        }, function () { throw new Error(''); });
      }

      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(''); return r.json(); })
        .then(function (cart) {
          var vars = eqVariantes();
          var ids = [], tope = null, j;
          for (j = 0; j < vars.length; j++) {
            ids.push(vars[j].id);
            if (String(vars[j].id) === String(varId)) tope = eqTope(vars[j]);
          }
          var yaEste = 0, yaInstal = 0, yaInodoros = 0;
          var items = cart.items || [];
          for (var i = 0; i < items.length; i++) {
            if (items[i].variant_id === varId) yaEste += items[i].quantity;
            if (items[i].variant_id === instalId) yaInstal += items[i].quantity;
            if (ids.indexOf(items[i].variant_id) !== -1) yaInodoros += items[i].quantity;
          }

          // Cuántas unidades caben de verdad: si el modelo ya está en el carrito
          // y no queda más stock, pedirlo otra vez hacía que Shopify rechazara
          // la operación entera y el cliente no podía añadir la instalación de
          // ninguna manera. Con la cuenta hecha sobre el stock real, esto sigue
          // siendo correcto el día que haya dos o más unidades por modelo.
          var inodorosNuevos = (tope == null) ? qty : Math.max(0, Math.min(qty, tope - yaEste));
          var pedir = [], objetivo = 0, diferencia = 0;
          // Se pidieron más de las que quedan: se añaden las que caben y se
          // avisa en vez de llevarle al carrito como si nada
          if (inodorosNuevos > 0 && inodorosNuevos < qty) {
            parcial = inodorosNuevos === 1
              ? 'Solo quedaba 1 unidad disponible de este modelo: hemos añadido 1 al carrito.'
              : 'Solo quedaban ' + inodorosNuevos + ' unidades disponibles de este modelo: las hemos añadido al carrito.';
          }
          function avisoStock() {
            var a = new Error(yaEste > 0
              ? (tope > 1
                  ? 'Ya tienes en el carrito todas las unidades disponibles de este modelo.'
                  : 'Ya tienes en el carrito la unidad disponible de este modelo.')
              : 'Ahora mismo no queda stock de este modelo.');
            a.eqStock = true;
            a.eqCarrito = yaEste > 0;
            return a;
          }

          if (!conInstal) {
            // Sin instalación: solo el inodoro, y nunca más unidades que stock.
            // Si ya no cabe ninguna, no se añade nada y se explica por qué.
            if (inodorosNuevos <= 0) throw avisoStock();
            pedir.push({ id: varId, quantity: inodorosNuevos });
          } else {
            // Con casilla pero sin stock y sin este modelo en el carrito: no
            // hay nada que instalar; se explica en vez de ir al carrito en blanco
            if (inodorosNuevos <= 0 && yaEste === 0) throw avisoStock();
            var inodorosFinal = yaInodoros + inodorosNuevos;
            // Dos reglas que se cumplen siempre:
            //  1) marcar la casilla pide instalación para las unidades de ahora
            //     (nunca para un inodoro que el cliente añadió sin ella);
            //  2) en el carrito nunca puede haber más instalaciones que inodoros
            //     — así se corrige sola una instalación que se quedara suelta al
            //     borrar su inodoro, que si no se cobraba dos veces.
            // Si no entra ninguna unidad nueva (el modelo ya está y no queda
            // stock), basta con que haya tantas instalaciones como unidades de
            // ESTE modelo: sumar una más cobraba una instalación de más cuando
            // el carrito tenía otro modelo añadido a propósito sin ella.
            objetivo = inodorosNuevos > 0 ? yaInstal + inodorosNuevos : Math.max(yaInstal, yaEste);
            if (ids.length && objetivo > inodorosFinal) objetivo = inodorosFinal;
            diferencia = objetivo - yaInstal;
            // El carrito no guarda a qué inodoro pertenece cada instalación.
            // Si este modelo ya está, no entra ninguno nuevo, no cambia nada y
            // hay inodoros sin instalación, no se puede saber si el cliente
            // quiere una más (p. ej. eQiik con instalación + Pro sin ella, y
            // ahora marca la casilla en el Pro) o si ya la tiene (eQiik sin
            // instalación + Pro con ella). En vez de adivinar —cobrar de más o
            // quedarse corto— se le avisa y se le deja decidir en el carrito.
            if (inodorosNuevos === 0 && diferencia === 0 && yaInstal < yaInodoros) {
              var dudoso = new Error('Este modelo ya está en tu carrito. Si quieres instalación para cada inodoro, ajústala allí.');
              dudoso.eqStock = true;
              dudoso.eqCarrito = true;
              throw dudoso;
            }
            // Se añade la instalación de este modelo, pero siguen quedando
            // inodoros sin ella: se avisa en vez de ir al carrito en silencio.
            if (inodorosNuevos === 0 && diferencia > 0 && objetivo < yaInodoros) {
              parcial = 'Hemos añadido la instalación. Aún hay inodoros sin instalación en tu carrito: si la quieres para cada uno, ajústala allí.';
            }
            if (inodorosNuevos > 0) pedir.push({ id: varId, quantity: inodorosNuevos });
            if (diferencia > 0) pedir.push({ id: instalId, quantity: diferencia });
          }

          var paso = pedir.length
            ? fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: pedir })
              }).then(function (r) { if (!r.ok) return fallo(r); yaAnadido = true; })
            : Promise.resolve();

          if (diferencia < 0) {
            // Sobran instalaciones (carrito heredado o inodoro borrado): se baja
            // la cantidad a la que corresponde en vez de dejarla mal para siempre.
            paso = paso.then(function () {
              var updates = {};
              updates[instalId] = objetivo;
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: updates })
              }).then(function (r) { if (!r.ok) return fallo(r); });
            });
          }
          return paso;
        })
        .then(function () {
          if (parcial) {
            // Ya está en el carrito; se queda aquí para leer el aviso
            restaurarBoton();
            aviso(parcial, true, true);
            return;
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          // Nunca se compra a medias ni «a ciegas»: si algo falla (también sin
          // conexión) no se envía el formulario normal con otra cantidad; se
          // avisa y no se añade nada.
          restaurarBoton();
          if (err && err.eqStock) {
            aviso(err.message, err.eqCarrito);
          } else if (yaAnadido) {
            // Caso raro: el artículo sí entró y lo que falló fue el ajuste de
            // la instalación. Decirle «no hemos podido añadirlo» sería mentira.
            aviso('Lo hemos añadido, pero revisa la instalación en el carrito antes de pagar.', true);
          } else {
            avisoError(err && err.message ? err.message : null);
          }
        });
    });
  }

  /* ---- Barra de compra fija (ficha) ----
     Cuando el botón de compra sale de la pantalla por arriba, aparece abajo
     una barra con el modelo y el precio. Su botón NO compra: lleva de vuelta
     al formulario y enfoca el botón, para no saltarse la cantidad ni la
     casilla de instalación. */
  function initSticky() {
    var barra = document.querySelector('[data-eq-sticky]');
    var form = document.querySelector('[data-eq-product-form]');
    if (!barra || !form || !('IntersectionObserver' in window)) return;
    var addBtn = form.querySelector('[data-eq-add]');
    if (!addBtn) return;
    var nombreEl = barra.querySelector('[data-eq-sticky-nombre]');
    var precioEl = barra.querySelector('[data-eq-sticky-precio]');
    var btn = barra.querySelector('[data-eq-sticky-btn]');
    var unica = barra.hasAttribute('data-unica');

    function pinta() {
      var v = eqVarianteActual(form);
      if (!v) return;
      if (nombreEl && !unica) nombreEl.textContent = v.title;
      // Con la casilla marcada, el mismo total que se ve junto al botón
      var check = form.querySelector('[data-eq-instal-check]');
      var extra = (check && check.checked) ? (parseInt(check.getAttribute('data-price'), 10) || 0) : 0;
      if (precioEl) {
        precioEl.textContent = money(v.price + extra);
        if (extra) {
          var nota = document.createElement('small');
          nota.className = 'eq-sticky__extra';
          nota.textContent = ' con instalación';
          precioEl.appendChild(nota);
        }
      }
      if (btn) {
        if (v.available) {
          btn.removeAttribute('disabled');
          btn.textContent = 'Ir a comprar';
        } else {
          btn.setAttribute('disabled', 'disabled');
          btn.textContent = 'Agotado';
        }
      }
    }
    document.addEventListener('eq:variant-change', pinta);
    var checkI = form.querySelector('[data-eq-instal-check]');
    if (checkI) checkI.addEventListener('change', pinta);
    window.addEventListener('pageshow', function (e) { if (e.persisted) pinta(); });
    pinta();

    var activa = false;
    function pon(on) {
      if (on === activa) return;
      activa = on;
      barra.classList.toggle('is-visible', on);
      document.body.classList.toggle('eq-con-sticky', on);
    }
    var obs = new IntersectionObserver(function (entries) {
      var en = entries[entries.length - 1];
      pon(!en.isIntersecting && en.boundingClientRect.top < 0);
    });
    obs.observe(addBtn);

    if (btn) btn.addEventListener('click', function () {
      var destino = document.querySelector('.eq-prod__optitle') ||
        document.querySelector('.eq-prod__variants') || form;
      var cab = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 80;
      var y = destino.getBoundingClientRect().top + window.pageYOffset - cab - 16;
      window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
      try { addBtn.focus({ preventScroll: true }); } catch (e) { addBtn.focus(); }
    });
  }

  /* ---- Barra de progreso de lectura (artículos del blog) ---- */
  function initProgreso() {
    var art = document.querySelector('.article-template__content');
    if (!art) return;
    var barra = document.createElement('div');
    barra.className = 'eq-progreso';
    barra.setAttribute('aria-hidden', 'true');
    var relleno = document.createElement('span');
    barra.appendChild(relleno);
    document.body.appendChild(barra);
    var pendiente = false;
    function calcula() {
      pendiente = false;
      var r = art.getBoundingClientRect();
      var recorrido = r.height - window.innerHeight;
      var p = recorrido > 0 ? -r.top / recorrido : (r.bottom <= window.innerHeight ? 1 : 0);
      p = Math.max(0, Math.min(1, p));
      relleno.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    }
    function pide() {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(calcula);
    }
    window.addEventListener('scroll', pide, { passive: true });
    window.addEventListener('resize', pide, { passive: true });
    calcula();
  }

  /* ---- DNI o NIF del carrito ----
     Se guarda solo mientras se escribe, igual que la nota del carrito. Si no,
     el dato solo llegaba al pulsar «Pagar pedido»: quien usara un pago rápido
     (PayPal, Shop Pay) perdía lo que había escrito sin enterarse.
     Además avisa si la letra no cuadra con el número, sin bloquear la compra. */
  function initDni() {
    var campo = document.querySelector('[data-eq-dni]');

    if (!campo) {
      // Sin campo en la página del carrito = carrito vacío. El dato personal no
      // debe quedarse pegado al navegador: si sobró de una compra anterior, se
      // borra para que no acabe en un pedido que no es el suyo.
      if (document.querySelector('[data-eq-dni-limpiar]')) {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (c) {
            if (c && c.item_count === 0 && c.attributes && c.attributes['DNI o NIF']) {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { 'DNI o NIF': '' } })
              });
            }
          })
          .catch(function () {});
      }
      return;
    }

    var aviso = document.querySelector('[data-eq-dni-aviso]');
    var reloj = null;

    function limpio(v) { return String(v || '').toUpperCase().replace(/[^0-9A-Z]/g, ''); }

    // Letra de control del DNI y del NIE. Un NIF de empresa (letra delante) no
    // sigue esta regla, así que en ese caso no se opina.
    var LETRAS = 'TRWAGMYFPDXBNJZSQVHLCKE';
    function pareceMal(v) {
      var m = v.match(/^([XYZ]?)(\d{7,8})([A-Z])$/);
      if (!m) return false; // no parece un DNI/NIE: no decimos nada
      var num = m[2];
      if (m[1]) num = String('XYZ'.indexOf(m[1])) + num;
      return LETRAS.charAt(parseInt(num, 10) % 23) !== m[3];
    }
    function revisar() {
      if (!aviso) return;
      var v = limpio(campo.value);
      if (v !== '' && pareceMal(v)) {
        aviso.textContent = 'Revisa el DNI: la letra no coincide con el número.';
        aviso.hidden = false;
      } else {
        aviso.hidden = true;
      }
    }
    function guardar() {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'DNI o NIF': limpio(campo.value) } })
      }).catch(function () {});
    }
    campo.addEventListener('input', function () {
      revisar();
      clearTimeout(reloj);
      reloj = setTimeout(guardar, 700);
    });
    campo.addEventListener('blur', function () {
      clearTimeout(reloj);
      campo.value = limpio(campo.value); // se ordena al salir, no mientras escribe
      revisar();
      guardar();
    });
    revisar();
  }

  function boot() {
    if (window.__eqBooted) return; // se carga una sola vez desde theme.liquid; init solo una vez
    window.__eqBooted = true;
    // Cada componente arranca por separado: si uno falla (p. ej. un
    // navegador raro), los demás —y sobre todo la compra— siguen funcionando.
    [initReveals, initCountUp, initFaq, initGallery, initVariants, initQty,
     initInstalacion, initEnvio, initSticky, initProgreso, initDni].forEach(function (fn) {
      try { fn(); } catch (e) { if (window.console) console.error('eQiik', e); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
